/* eslint-disable i18next/no-literal-string */
import { useState, useSyncExternalStore } from "react";
import Button from "@/components/ui/button.tsx";
import { DiagnosticsList } from "@/features/diagnostics/components/lib/diagnostics.tsx";
import { EventLogStatus } from "@/features/diagnostics/resources/constants.ts";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import type { EventLogStatusEnum } from "@/features/diagnostics/types";
import type { Nullable } from "@/types";
import { formatCompactNumber } from "@/utils/formatters.ts";
import { cn } from "@/utils/style.ts";
import { DiagnosticsEmpty } from "../lib/diagnostics-card.tsx";
import EventLogItem from "./event-log-item.tsx";

export default function EventLogList() {
    const eventLogs = useSyncExternalStore(DiagnosticsStore.subscribe, () => DiagnosticsStore.eventLogs);

    const [status, setStatus] = useState<Nullable<EventLogStatusEnum>>(null);

    const events = eventLogs.filter((event) => (status ? event.status === status : true));

    const toggleStatus = (eventStatus: EventLogStatusEnum) => {
        return () => {
            setStatus((current) => (current === eventStatus ? null : eventStatus));
        };
    };

    return (
        <>
            <div className="event-log-filters">
                {Object.values(EventLogStatus).map((eventStatus) => {
                    const total = eventLogs.reduce<number>((acc, log) => {
                        if (log.status === eventStatus) acc++;

                        return acc;
                    }, 0);

                    return (
                        <Button
                            key={eventStatus}
                            onClick={toggleStatus(eventStatus)}
                            className={cn(
                                "event-log-filter",
                                `event-log-filter--${eventStatus}`,
                                status === eventStatus && "event-log-filter--active",
                            )}
                        >
                            {eventStatus} ({formatCompactNumber(total)})
                        </Button>
                    );
                })}
            </div>
            {events.length > 0 ? (
                <DiagnosticsList>
                    {events.map((log, index) => (
                        <EventLogItem key={index} log={log} />
                    ))}
                </DiagnosticsList>
            ) : (
                <DiagnosticsEmpty>No events recorded!</DiagnosticsEmpty>
            )}
        </>
    );
}
